import React from "react";
import "./style.scss";

export function Footer() {
    return <div className="footer-copyright">&#9400; Copyright 2022 ABB</div>;
}
